import React from 'react';
import './Styles/Banner.scss';
import image from '../../../Assets/Cards/collaborationImg.webp';
import profile from '../../../Assets/Cards/profile1.png';
import {ImReply} from 'react-icons/im';
import {FaCircle} from 'react-icons/fa';
import Tilt from 'react-parallax-tilt';
const Banner=()=>{
    return(
        <div className="collaboration-banner">
          <h1>Make HostDesign your centralised space for collaborative ideas, design feedback and iterations</h1>
          <div className="image-part">
          <Tilt scale={1.01} transitionSpeed={3500}>
              <img className="mainimg" src={image} />
              </Tilt>
              <div className="testimonial" data-aos="zoom-in"
              data-aos-delay={200}>
                        <div className="name">
                         <img  src={profile} />
                         <h3>John Petla</h3>
                        </div>
                        <p>we need more work here. Please add some images here.</p>
                         <div className="post">
                             <p>Just Now</p>
                             <p> Mark as done</p>
                             <p>Reply</p>
                         </div>
                    </div>
          </div>
        </div>
    )
};
export default Banner ;